import React from 'react';
import LegalLayout from '../components/LegalLayout';

const Section = ({ title, children }) => (
  <section>
    <h2 className="serif text-3xl md:text-4xl tracking-tight text-obsidian mb-4">{title}</h2>
    <div className="space-y-4">{children}</div>
  </section>
);

export default function TermsOfUse() {
  return (
    <LegalLayout title="Terms of Use" updated="July 14, 2026">
      <p>
        These Terms of Use (“Terms”) govern your access to and use of the website operated by{' '}
        <strong>13150259 Canada Inc.</strong>, operating as “RaufMedia” (“we”, “us”, or “our”). By
        accessing or using this website, you agree to be bound by these Terms.
      </p>

      <Section title="1. Use of the Website">
        <p>
          You may use this website for lawful purposes only. You agree not to use the website in any
          way that could damage, disable, or impair it, or interfere with any other party’s use of
          it.
        </p>
      </Section>

      <Section title="2. Intellectual Property">
        <p>
          All content on this website — including text, design, graphics, 3D assets, code, logos,
          and the RaufMedia brand — is the property of 13150259 Canada Inc. or its licensors and is
          protected by applicable intellectual property laws. You may not reproduce, distribute, or
          create derivative works without our prior written consent.
        </p>
      </Section>

      <Section title="3. Contact Submissions">
        <p>
          Information you submit through our contact form is handled in accordance with our{' '}
          <a href="/privacy" className="text-signal">Privacy Policy</a>. You represent that the
          information you provide is accurate and that you have the right to share it.
        </p>
      </Section>

      <Section title="4. Services & No Guarantee">
        <p>
          Any project timelines, results, metrics, or outcomes referenced on this website are
          illustrative and do not constitute a guarantee. Specific deliverables and terms are defined
          in a separate written agreement for each engagement.
        </p>
      </Section>

      <Section title="5. Third-Party Links">
        <p>
          This website may contain links to third-party sites. We are not responsible for the
          content, policies, or practices of any third-party websites.
        </p>
      </Section>

      <Section title="6. Disclaimer & Limitation of Liability">
        <p>
          This website is provided “as is” without warranties of any kind. To the maximum extent
          permitted by law, 13150259 Canada Inc. shall not be liable for any indirect, incidental, or
          consequential damages arising from your use of the website.
        </p>
      </Section>

      <Section title="7. Governing Law">
        <p>
          These Terms are governed by the laws of the Province of British Columbia and the federal
          laws of Canada applicable therein, without regard to conflict-of-law principles.
        </p>
      </Section>

      <Section title="8. Changes to These Terms">
        <p>
          We may update these Terms from time to time. Continued use of the website after changes are
          posted constitutes acceptance of the revised Terms.
        </p>
      </Section>

      <Section title="9. Contact">
        <p className="text-obsidian">
          13150259 Canada Inc. (RaufMedia)<br />
          Email: <a href="mailto:meet@raufmedia.com" className="text-signal">meet@raufmedia.com</a><br />
          Phone: <a href="tel:+16043689865" className="text-signal">+1 604 368 9865</a>
        </p>
      </Section>

      <p className="text-xs text-graphite/70 pt-6 border-t border-black/10">
        This document is provided as a general template and does not constitute legal advice. We
        recommend having it reviewed by qualified legal counsel for your jurisdiction.
      </p>
    </LegalLayout>
  );
}
